import { FormControl, FormLabel, Grid } from "@mui/material";
import { FC } from "react";
import { QuestionnaireItemProps } from ".";
import DictationControl from "../../../../../components/dictation/DictationControl";
import { kebabCase } from "lodash";

const StringQuestion: FC<QuestionnaireItemProps> = ({
  item,
  onChange,
  value,
  initialValue,
  disabled,
}) => {
  return (
    <Grid>
      <FormControl fullWidth>
        <FormLabel>{item.text}</FormLabel>
        <DictationControl
          fullWidth={true}
          variant="outlined"
          name={kebabCase(item.linkId + item.text + "string")}
          defaultValue={initialValue}
          value={value?.value || initialValue}
          onTextChange={(e) => onChange(item, e)}
          disabled={disabled}
        />
      </FormControl>
    </Grid>
  );
};

export default StringQuestion;
